import React, { Component, Fragment } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CCol,
  CButton,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter
} from "@coreui/react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { InputGroup, Input, InputGroupAddon, InputGroupText } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentItem from "../../../components/Content/ContentItem";
import Loading from "../../../components/Loading";
import NewTutorialModal from "../../../components/NewTutorialModal";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

const appRoot = document.getElementById("root");

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="danger"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar tutorial</CModalHeader>
        <CModalBody>Deseja apagar o tutorial?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => this.props.onDelete()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </CModal>,
      this.el
    );
  }
}

class Tutorials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingManual: true,
      loadingVideo: true,
      filters: {},
      manuals: [],
      videos: [],
      filter: {
        word: null
      },
      typeManual: 29,
      typeVideo: 30,
      tutorialModal: false,
      deleteModal: false,
      deleteId: null,
      edit: false,
      contentId: null
    };
  }

  componentDidMount() {
    this.getLos();
  }

  getLos = () => {
    this.setState({ loadingManual: true, loadingVideo: true });

    let tag = "P";

    if (
      ["ava.livros.homologa.educandus", "ava.livros.educandus"].includes(
        window.location.host.toLowerCase()
      )
    ) {
      tag = "L";
    } else if (
      ["ava.avaliacao.homologa.educandus", "ava.avaliacao.educandus"].includes(
        window.location.host.toLowerCase()
      )
    ) {
      tag = "A";
    }

    // Manuais

    const manualFilters = {
      type: this.state.typeManual,
      word: this.state.filters.word,
      tag
    };

    axios
      .post(`${URL.api}content/los/listLosFilter`, manualFilters, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ manuals: resp.data.data, loadingManual: false });
      });

    // Vídeos

    const videoFilters = {
      type: this.state.typeVideo,
      word: this.state.filters.word,
      tag
    };

    axios
      .post(`${URL.api}content/los/listLosFilter`, videoFilters, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ videos: resp.data.data, loadingVideo: false });
      });
  };

  filter(filters) {
    this.setState({ filters }, () => {
      this.getLos();
    });
  }

  changeFilter(prop, value) {
    this.setState(state => {
      let filter = { ...state.filter };
      filter[prop] = value;

      return { filter, filters: filter };
    });
  }

  deleteContent() {
    axios
      .post(
        `${URL.api}content/los/delete/${this.state.deleteId}`,
        {},
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        this.getLos();
        this.setState({ deleteModal: false, deleteId: null });
      });
  }

  render() {
    const { manuals, videos, loadingManual, loadingVideo } = this.state;

    return (
      <div className="animated">
        {this.state.tutorialModal && (
          <NewTutorialModal
            show={this.state.tutorialModal}
            onClose={() =>
              this.setState({
                tutorialModal: false,
                edit: false,
                contentId: null
              })
            }
            onSave={() =>
              this.setState({ tutorialModal: false }, () =>
                this.filter(this.state.filter)
              )
            }
            type={this.state.tutorialModal}
            contentId={this.state.contentId}
            edit={this.state.edit}
          />
        )}
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div className="d-flex align-items-center mb-1">
                <h4 className="card-title m-0 border-0 mr-1">Tutoriais</h4>
              </div>
              <div className="small text-muted">Veja todos os tutoriais</div>
            </div>
            <div
              className="float-right d-none d-lg-block"
              style={{ width: "30%" }}
            >
              <InputGroup>
                <Input
                  placeholder="Pesquisar"
                  onChange={e => this.changeFilter("word", e.target.value)}
                  value={this.state.filter.word}
                  type="text"
                  style={{
                    borderRight: 0,
                    outline: 0,
                    borderColor: "#d8dbe0",
                    boxShadow: "none"
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText className="bg-white pl-0">
                    <i
                      className="fa fa-search text-muted content-search-icon"
                      onClick={() => this.filter(this.state.filter)}
                    ></i>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </CCardHeader>
          <CCardBody>
            <div className="cardContent" style={{ minHeight: 0 }}>
              <h5
                className="mb-4 pb-2"
                style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}
              >
                Manuais
              </h5>
              {loadingManual ? (
                <Loading />
              ) : manuals.length > 0 ||
                this.props.general.active_roles.role_id === 1 ? (
                <div className="contentArea row">
                  {this.props.general.active_roles.role_id === 1 && (
                    <CCol xs="12" md="6" lg="4" xl="3">
                      <div
                        className="contentItemCard mt-3"
                        onClick={() =>
                          this.setState({ tutorialModal: "manual" })
                        }
                      >
                        <div className="contentItemFooter p-3 pr-4 text-muted">
                          <i className="contentIcon fa fa-plus text-muted mr-2"></i>
                          <div className="contentTitle">Adicionar manual</div>
                        </div>
                      </div>
                    </CCol>
                  )}
                  {manuals.map((type, idt) => (
                    <Fragment key={`type-${idt}`}>
                      {type.content.map((content, idc) => (
                        <CCol xs="12" md="6" lg="4" xl="3" key={`type-${idc}`}>
                          <ContentItem
                            type={this.state.typeManual}
                            activity={false}
                            key={`content-${type.id}-${content.id}`}
                            content={content}
                            icon="life-ring"
                            color="purple"
                            hidePopover
                            currentRoute={this.props.currentRoute}
                            menu={
                              this.props.general.active_roles.role_id === 1 && [
                                {
                                  text: "Editar",
                                  onClick: () =>
                                    this.setState({
                                      tutorialModal: "manual",
                                      contentId: content.id,
                                      edit: true
                                    })
                                },
                                {
                                  text: "Excluir",
                                  onClick: () =>
                                    this.setState({
                                      deleteModal: true,
                                      deleteId: content.id
                                    })
                                }
                              ]
                            }
                          />
                        </CCol>
                      ))}
                    </Fragment>
                  ))}
                </div>
              ) : (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Nenhum manual encontrado
                </div>
              )}
              <h5
                className="mt-4 mb-4 pb-2"
                style={{ borderBottom: "1px solid rgba(0,0,0,.125)" }}
              >
                Vídeos
              </h5>
              {loadingVideo ? (
                <Loading />
              ) : videos.length > 0 ||
                this.props.general.active_roles.role_id === 1 ? (
                <div className="contentArea row">
                  {this.props.general.active_roles.role_id === 1 && (
                    <CCol xs="12" md="6" lg="4" xl="3">
                      <div
                        className="contentItemCard mt-3"
                        onClick={() =>
                          this.setState({ tutorialModal: "video" })
                        }
                      >
                        <div className="contentItemFooter p-3 pr-4 text-muted">
                          <i className="contentIcon fa fa-plus text-muted mr-2"></i>
                          <div className="contentTitle">Adicionar vídeo</div>
                        </div>
                      </div>
                    </CCol>
                  )}
                  {videos.map((type, idt) => (
                    <Fragment key={`type-${idt}`}>
                      {type.content.map((content, idc) => (
                        <CCol xs="12" md="6" lg="4" xl="3" key={`type-${idc}`}>
                          <ContentItem
                            type={this.state.typeVideo}
                            activity={false}
                            key={`content-${type.id}-${content.id}`}
                            content={content}
                            icon="play-circle"
                            color="danger"
                            hidePopover
                            currentRoute={this.props.currentRoute}
                            menu={
                              this.props.general.active_roles.role_id === 1 && [
                                {
                                  text: "Editar",
                                  onClick: () =>
                                    this.setState({
                                      tutorialModal: "video",
                                      contentId: content.id,
                                      edit: true
                                    })
                                },
                                {
                                  text: "Excluir",
                                  onClick: () =>
                                    this.setState({
                                      deleteModal: true,
                                      deleteId: content.id
                                    })
                                }
                              ]
                            }
                          />
                        </CCol>
                      ))}
                    </Fragment>
                  ))}
                </div>
              ) : (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Nenhum vídeo encontrado
                </div>
              )}
            </div>
          </CCardBody>
        </CCard>
        <DeleteModal
          show={this.state.deleteModal}
          onClose={() => this.setState({ deleteModal: false })}
          onDelete={() => this.deleteContent()}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Tutorials);
